// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/images/welcome.svg", import.meta.url);
// Module
var code = `<template>
  <require from="./welcome-widget.scss"></require>
  <global-progress if.bind="loading" size="50" stroke-width="5"></global-progress>

  <div if.bind="!loading && !error" class="welcome-widget welcome-widget-\${id}" css="--welcome-widget-font-family: \${font || ''}; --welcome-widget-font-size: \${fontSize ? fontSize + 'px' : ''}; --welcome-widget-title-font-size: \${titleFontSize ? titleFontSize + 'px' : ''}; --welcome-widget-color: \${color | widgetTemplateColor:isInDashboard};">
    <div class="welcome-widget__title">Welcome back.</div>
    <div class="welcome-widget__links">You have:
      <a href="/documents">\${vouchersCount} unprocessed voucher\${vouchersCount !== 1 ? 's' : ''}</a> and
      <a href="/notifications">\${notificationsCount} notification\${notificationsCount !== 1 ? 's' : ''}</a>
    </div>
    <img src="${___HTML_LOADER_IMPORT_0___}">
  </div>
  <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
    \${error.message}
  </message>
</template>
`;
// Exports
export default code;